// Local electronics products to augment catalog (with 50% discount)

export const localElectronics = [
  {
    id: 'e-local-15',
    title: 'Airpods 2 – Classic Wireless',
    price: 7,
    description: 'Airpods 2nd Gen: Classic wireless sound, easy pairing, and all-day comfort. 40% OFF for a limited time!',
    category: 'electronics',
    image: 'https://images.priceoye.pk/apple-airpods-2nd-generation-pakistan-priceoye-haa94-500x500.webp',
    discountRate: 0.6,
    rating: { rate: 4.9, count: 24 }
  },
  {
    id: 'e-local-16',
    title: 'Airpods Mini – Compact Sound',
    price: 14,
    description: 'Airpods Mini: Compact, clear audio and hands-free convenience. Now 20% OFF — great budget pick for daily use!',
    category: 'electronics',
  image: 'https://images.priceoye.pk/zero-aura-earbuds-pakistan-priceoye-tmhva-500x500.webp',
    discountRate: 0.8,
    rating: { rate: 4.2, count: 18 }
  },
  {
    id: 'e-local-17',
    title: 'Airpods Arcade – Bass Boost',
    price: 13,
    description: 'Airpods Arcade: Gaming-tuned bass, low-latency mode, and durable fit. 60% OFF for a short time!',
    category: 'electronics',
    image: 'https://images.priceoye.pk/zero-arcade-800-wireless-earbuds-pakistan-priceoye-r4617-500x500.webp',
    discountRate: 0.4,
    rating: { rate: 4.3, count: 22 }
  },
  {
    id: 'e-local-14',
    title: 'Airpods Pro 2 Type-C',
    price: 11,
    description: 'Airpods Pro 2nd Gen Type-C: ANC, wireless charging, and premium sound. 50% OFF for a limited time!',
    category: 'electronics',
    image: 'https://images.priceoye.pk/apple-airpods-pro-2nd-generation-type-c-pakistan-priceoye-mg85z-500x500.webp',
    discountRate: 0.5,
    dealType: 'Flash Deal',
    rating: { rate: 4.9, count: 40 }
  },
  {
    id: 'e-local-13',
    title: 'Airpods 4 – Next Gen Wireless',
    price: 13,
    description: 'Airpods 4: Next generation wireless sound, ergonomic fit, and long battery life. 50% OFF for a limited time!',
    category: 'electronics',
    image: 'https://images.priceoye.pk/apple-airpods-4-pakistan-priceoye-8eiyy-500x500.webp',
    discountRate: 0.5,
    rating: { rate: 4.8, count: 60 }
  },
  {
    id: 'e-local-12',
    title: 'Airpods 3 – Wireless Freedom',
    price: 11,
    description: 'Airpods 3: Crisp sound, wireless charging, and ergonomic fit. Great for music, calls, and daily use. Now 40% OFF!',
    category: 'electronics',
    image: 'https://cdn.fskasur.com/wp-content/uploads/2022/04/icool-airpods-3-e1709376593919.jpg',
    discountRate: 0.6,
    rating: { rate: 4.5, count: 80 }
  },
  {
    id: 'e-local-11',
    title: 'Airpods Pro – Premium Sound',
  price: 18,
    description: 'Airpods Pro: Active noise cancellation, wireless charging, and immersive sound. Perfect for music, calls, and workouts. Limited time 50% OFF!',
    category: 'electronics',
  image: 'https://appleman.pk/cdn/shop/products/Airpods-Pro-1.jpg?v=1667316352&width=493',
    discountRate: 0.5,
    dealType: 'Deal of the Day',
    rating: { rate: 4.7, count: 120 }
  },
  {
    id: 'e-local-1',
    title: "Wireless Earbuds with Charging Case",
    price: 49.99,
    description: "True wireless earbuds with Bluetooth 5, auto‑pairing, touch controls, clear calls, and up to 24 hours total playtime with the pocket charging case.",
    category: "electronics",
    image: "https://images.pexels.com/photos/788946/pexels-photo-788946.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=600",
    discountRate: 0.5,
    rating: { rate: 4.5, count: 210 }
  },
  {
    id: 'e-local-2',
    title: '15.6" Laptop with Backlit Keyboard',
    price: 899.0,
    description: "Slim performance laptop featuring a vivid 15.6‑inch display, backlit keyboard, fast SSD storage and all‑day battery — great for study, work and creation.",
    category: "electronics",
    image: "https://images.pexels.com/photos/2047905/pexels-photo-2047905.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=600",
    discountRate: 0.5,
    dealType: 'Limited Time',
    rating: { rate: 4.3, count: 145 }
  },
  {
    id: 'e-local-3',
    title: "Compact Quadcopter Drone (4K Camera)",
    price: 599.0,
    description: "Foldable aerial drone with stabilized 4K camera, beginner and pro flight modes, return‑to‑home safety and up to 25 minutes of flight per charge.",
    category: "electronics",
    image: "https://images.pexels.com/photos/744366/pexels-photo-744366.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=600",
    discountRate: 0.5,
    dealType: 'Flash Deal',
    rating: { rate: 4.2, count: 320 }
  },
  {
    id: 'e-local-4',
    title: "DSLR Camera Kit (18–55mm Lens)",
    price: 449.0,
    description: "Entry‑level DSLR with 24MP sensor, optical viewfinder and included 18–55mm zoom lens — perfect for learning photography and everyday shooting.",
    category: "electronics",
    image: "https://images.pexels.com/photos/51383/photo-camera-subject-photographer-51383.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=600",
    discountRate: 0.5,
    rating: { rate: 4.4, count: 275 }
  },
  {
    id: 'e-local-5',
    title: "Mirrorless Camera Body (24MP)",
    price: 699.0,
    description: "Compact mirrorless camera with fast autofocus, 24MP APS‑C sensor and 4K video — lightweight gear for travel, street and content creation.",
    category: "electronics",
    image: "https://images.pexels.com/photos/306763/pexels-photo-306763.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=600",
    discountRate: 0.5,
    rating: { rate: 4.1, count: 190 }
  },
  {
    id: 'e-local-6',
    title: "Single‑Board Computer (Quad‑Core)",
    price: 59.0,
    description: "Credit‑card sized board computer featuring a quad‑core CPU, 1GB RAM, HDMI, USB and GPIO — ideal for DIY projects, robotics and learning to code.",
    category: "electronics",
    image: "https://images.pexels.com/photos/163073/raspberry-pi-computer-linux-163073.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=600",
    discountRate: 0.5,
    rating: { rate: 4.6, count: 510 }
  },
  {
    id: 'e-local-7',
    title: "Micro‑ATX Computer Motherboard",
    price: 129.0,
    description: "Reliable micro‑ATX motherboard with high‑speed NVMe support, multiple USB ports and modern connectivity for home and office PC builds.",
    category: "electronics",
    image: "https://images.pexels.com/photos/163125/board-printed-circuit-board-computer-electronics-163125.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=600",
    discountRate: 0.5,
    rating: { rate: 4.0, count: 160 }
  },
  {
    id: 'e-local-8',
    title: "Over‑Ear Studio Headphones",
    price: 69.0,
    description: "Closed‑back studio headphones with cushioned ear cups, balanced sound and detachable cable — comfortable for long listening and editing sessions.",
    category: "electronics",
    subcategory: 'handfree',
    hidePrice: true,
    image: "https://images.pexels.com/photos/205926/pexels-photo-205926.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=600",
    discountRate: 0.5,
    rating: { rate: 4.3, count: 230 }
  },
  {
    id: 'e-local-9',
    title: "Wired Earbuds with Inline Mic",
    price: 19.0,
    description: "Tangle‑resistant wired earbuds with comfortable fit, clear microphone for calls and in‑line controls — great for phones, laptops and daily use.",
    category: "electronics",
    image: "https://images.pexels.com/photos/583842/pexels-photo-583842.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=600",
    discountRate: 0.5,
    rating: { rate: 4.2, count: 300 }
  },
  {
    id: 'e-local-10',
    title: "Portable Gaming Console",
    price: 299.0,
    description: "Handheld gaming console with bright display, dual joysticks and long‑lasting battery — play indie hits and retro classics on the go.",
    category: "electronics",
    image: "https://images.pexels.com/photos/682933/pexels-photo-682933.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=600",
    discountRate: 0.5,
    rating: { rate: 4.5, count: 410 }
  }
  ,
  {
    id: 'e-local-18',
    title: 'Zero Wave Pro Earbuds',
    price: 8,
    description: 'Zero Wave Pro: compact TWS earbuds with ENC and Type-C charging. Great value pick with a strong discount.',
    category: 'electronics',
    image: 'https://images.priceoye.pk/zero-wave-pro-earbuds-pakistan-priceoye-r86j3-500x500.webp',
    discountRate: 0.4,
    rating: { rate: 4.6, count: 48 },
    isNew: true
  },
  {
    id: 'e-local-19',
    title: 'Zero Arcade 900 Wireless Earbuds',
    price: 9,
    description: 'Zero Arcade 900: gaming‑oriented earbuds with boosted bass and low latency mode. Excellent for gamers on a budget.',
    category: 'electronics',
    image: 'https://images.priceoye.pk/zero-arcade-900-wireless-earbuds-pakistan-priceoye-qd68v-500x500.webp',
    discountRate: 0.55,
    rating: { rate: 4.4, count: 36 },
    isNew: true,
    newLabel: 'Just In'
  },
  {
    id: 'e-local-20',
    title: 'Zero J-10C Earbuds',
    price: 11,
    description: 'Zero J-10C: reliable TWS earbuds with up to 5–6 hours playtime and Type‑C charging. Great everyday option.',
    category: 'electronics',
    image: 'https://images.priceoye.pk/zero-j-10c-earbuds-pakistan-priceoye-vhkgs-500x500.webp',
    discountRate: 0.55,
    rating: { rate: 4.3, count: 29 }
  },
  {
    id: 'e-local-21',
    title: 'Audionic Jionee 2 — JoltBass True Wireless Earbuds',
    price: 1.5,
    description: 'Audionic Jionee 2: Punchy bass, long playtime and reliable call quality — budget TWS with premium features.',
    category: 'electronics',
    image: 'https://audionic.co/cdn/shop/files/Jionee_2.jpg?v=1674137385',
    discountRate: 0.6,
    rating: { rate: 4.79, count: 198 },
    isNew: true
  }
  ,
  {
    id: 'e-local-22',
    title: 'Audionic Jionee Wired Handfree — ClearCall Pro',
    price: 1.5,
    description: 'Wired Handfree by Audionic (Jionee series): ClearCall Pro with in-line mic, tangle‑resistant cable and punchy bass — perfect wired handfree for calls and music.',
    category: 'electronics',
    subcategory: 'handfree',
    image: 'https://audionic.co/cdn/shop/files/Jionee_2.jpg?v=1674137385',
    discountRate: 0.6,
    rating: { rate: 4.7, count: 150 }
  }
  ,
  {
    id: 'e-local-23',
    title: 'Login L-300 Wired Handfree — BassBoost Lite (Black) 500',
    price: 1.8,
    description: 'Login L-300 Wired Handfree — BassBoost Lite with clear mic and durable cable. Affordable wired handfree for calls and music.',
    category: 'electronics',
    subcategory: 'handfree',
    image: 'https://login.com.pk/cdn/shop/files/L-300handsfreecorrectcopy.webp?v=1758110707',
    discountRate: 0.6,
    rating: { rate: 4.2, count: 48 }
  },
  {
    id: 'e-local-24',
    title: 'Login L-300 Wired Handfree — BassBoost Pro (Premium) 700',
    price: 2.5,
    description: 'Login L-300 Wired Handfree — BassBoost Pro with reinforced cable and rich bass response. A step up for better audio.',
    category: 'electronics',
    subcategory: 'handfree',
    image: 'https://login.com.pk/cdn/shop/files/L-300handsfreecorrectcopy5.webp?v=1758110707',
    discountRate: 0.65,
    rating: { rate: 4.3, count: 36 }
  },
  {
    id: 'e-local-25',
    title: 'Login L-300 Wired Handfree — BassBoost Max (Deluxe) 900',
    price: 3.2,
    description: 'Login L-300 Wired Handfree — BassBoost Max with premium drivers and metal pin for crystal sound. Designed for power users.',
    category: 'electronics',
    subcategory: 'handfree',
    image: 'https://login.com.pk/cdn/shop/files/L-300_handsfree_correct_copy_New_copy.webp?v=1758110708',
    discountRate: 0.45,
    rating: { rate: 4.4, count: 22 }
  },
  {
    id: 'e-local-26',
    title: 'Login L-303 Wired Handfree — ComfortFit (400)',
    price: 1.5,
    description: 'Login L-303 Handsfree — ComfortFit in-ear design with TPE cable and clear vocals. Great daily wired handfree.',
    category: 'electronics',
    subcategory: 'handfree',
    image: 'https://login.com.pk/cdn/shop/files/L-303HandsfreeBlack_b9d2a761-c756-432b-aa83-fe482068077b.webp?v=1758111251',
    discountRate: 0.6,
    rating: { rate: 4.1, count: 40 }
  },
  {
    id: 'e-local-27',
    title: 'Login L-301 Wired Handfree — ClearTalk (400)',
    price: 1.5,
    description: 'Login L-301 Handsfree — ClearTalk with built-in mic and wide compatibility. Reliable wired handfree for calls and music.',
    category: 'electronics',
    subcategory: 'handfree',
    image: 'https://login.com.pk/cdn/shop/files/L-301handsfreecorrectBlack.webp?v=1758111128',
    discountRate: 0.6,
    rating: { rate: 4.2, count: 28 }
  }
  ,
  {
    id: 'e-local-28',
    title: 'Login L-302 Wired Handfree — CrystalTone Pro (1000)',
    price: 3.6,
    description: 'Login L-302 Wired Handfree — CrystalTone Pro with crisp audio, tangle‑resistant cable and comfortable fit. Premium wired handfree for calls and music.',
    category: 'electronics',
    subcategory: 'handfree',
    image: 'https://login.com.pk/cdn/shop/files/L-302Red.webp?v=1758111411',
    discountRate: 0.65,
    rating: { rate: 4.3, count: 34 }
  }
  ,
  {
    id: 'e-local-29',
    title: 'Samsung EP-T2510 Mini 25W Adapter',
    price: 1.5,
    description: 'Compact 25W Samsung travel adapter — reliable fast charging. Great everyday wall adapter (charger).',
    category: 'electronics',
    image: 'https://images.priceoye.pk/samsung-ep-t2510-25w-2-pin-low-standby-energy-efficiency-super-fast-charging-power-adapter-pakistan-priceoye-8iof5-500x500.webp',
    discountRate: 0.6,
    rating: { rate: 4.5, count: 48 }
  },
  {
    id: 'e-local-30',
    title: 'Beclad 45W Type-C Rapid Adapter',
    price: 1.6,
    description: 'Beclad 45W Type-C adapter — compact PD charger for fast charging phones and tablets. Includes safety protections.',
    category: 'electronics',
    image: 'https://images.priceoye.pk/beclad-45w-type-c-adapter-pakistan-priceoye-qat63-500x500.webp',
    discountRate: 0.55,
    rating: { rate: 4.6, count: 32 }
  },
  {
    id: 'e-local-31',
    title: 'Samsung 45W Travel Adapter (Type-C Cable)',
    price: 1.8,
    description: '45W Samsung travel adapter with Type‑C cable — high‑speed charging on the go. A compact charger for modern devices.',
    category: 'electronics',
    image: 'https://images.priceoye.pk/samsung-2-pin-travel-adapter-45w-type-c-c-cable-pakistan-priceoye-jb1z5-500x500.webp',
    discountRate: 0.5,
    dealType: 'Bundle Deal',
    rating: { rate: 4.7, count: 54 }
  },
  {
    id: 'e-local-32',
    title: 'Motorola MC-307 Turbo Power Adapter',
    price: 2.0,
    description: 'Motorola MC-307 turbo adapter — efficient fast charger for phones. Built for safe, reliable charging.',
    category: 'electronics',
    image: 'https://images.priceoye.pk/motorola-mc-307-turbo-power-adapter-pakistan-priceoye-1tbw9-500x500.webp',
    discountRate: 0.65,
    rating: { rate: 4.4, count: 21 }
  },
  {
    id: 'e-local-33',
    title: 'Airox AD05 QC3.0 Fast Adapter',
    price: 2.1,
    description: 'Airox AD05 with QC3.0 support — quick charger for compatible devices. Reliable and compact charger/adapter.',
    category: 'electronics',
    image: 'https://images.priceoye.pk/airox-ad05-fast-adapter-qc-3-0-pakistan-priceoye-wlbyk-500x500.webp',
    discountRate: 0.7,
    rating: { rate: 4.3, count: 26 }
  },
  {
    id: 'e-local-34',
    title: 'Airox AD-06 Multi‑Port Adapter',
    price: 2.5,
    description: 'Airox AD-06 multi‑port adapter — versatile charger with multiple outputs for phones and tablets.',
    category: 'electronics',
    image: 'https://images.priceoye.pk/airox-adapter-airox-ad-06-amp-pakistan-priceoye-7il0l-500x500.webp',
    discountRate: 0.5,
    dealType: 'Limited Time',
    rating: { rate: 4.2, count: 19 }
  },
  {
    id: 'e-local-35',
    title: 'Infinix XC06 30W Charger Kit',
    price: 2.9,
    description: 'Infinix XC06 30W charger kit — fast PD charger with included cable. Compact wall charger for daily use.',
    category: 'electronics',
    image: 'https://images.priceoye.pk/infinix-xc06-kit-30w-charger-pakistan-priceoye-ft1l4-500x500.webp',
    discountRate: 0.45,
    rating: { rate: 4.6, count: 38 }
  },
  {
    id: 'e-local-36',
    title: 'Mars MI‑Flash Multi‑Protocol 25W Charger',
    price: 3.2,
    description: 'Mars MI‑Flash 25W multi‑protocol charger — versatile 25W charger for phones with mixed protocols support.',
    category: 'electronics',
    image: 'https://images.priceoye.pk/mars-mi-flash-multi-protocol-25w-charger-pakistan-priceoye-npge2-500x500.webp',
    discountRate: 0.6,
    rating: { rate: 4.5, count: 41 }
  }
  ,
  {
    id: 'e-local-37',
    title: 'New Arrival — Joyroom RapidCharge Pro Nylon Cable',
    price: 2.1,
    description: 'Joyroom RapidCharge Pro — braided nylon Type‑C cable for fast sync and long life. New Arrival!',
    category: 'electronics',
    subcategory: 'cable',
    image: 'https://images.priceoye.pk/joyroom-sa32-100w-usb-a-to-type-c-nylon-braided-cable-pakistan-priceoye-sr96a-500x500.webp',
    discountRate: 1.0,
    rating: { rate: 4.5, count: 48 }
  },
  {
    id: 'e-local-38',
    title: 'Airox CB04 SlimCharge Data Cable — 35% OFF',
    price: 1.6,
    description: 'Airox CB04 SlimCharge — reliable Type‑C data cable with solid build and fast transfer. Limited 35% discount.',
    category: 'electronics',
    subcategory: 'cable',
    image: 'https://images.priceoye.pk/airox-cb04-usb-data-cable-pakistan-priceoye-wlzih-500x500.webp',
    discountRate: 0.65,
    rating: { rate: 4.4, count: 36 }
  },
  {
    id: 'e-local-39',
    title: 'New Arrival — Anker Zolo TurboFlex USB‑C Cable',
    price: 2.1,
    description: 'Anker Zolo TurboFlex — ultra‑durable braided USB‑C to USB‑C cable offering fast charging and high transfer speeds. New Arrival!',
    category: 'electronics',
    subcategory: 'cable',
    image: 'https://images.priceoye.pk/anker-zolo-usb-c-to-usb-c-240w-fast-charging-data-a8060h12-pakistan-priceoye-qcn05-500x500.webp',
    discountRate: 1.0,
    rating: { rate: 4.7, count: 58 }
  },
  {
    id: 'e-local-40',
    title: 'Joyroom S‑UC027A9 UltraSafe Type‑C Cable — 35% OFF',
    price: 1.8,
    description: 'Joyroom UltraSafe S‑UC027A9 — compact, fast 3A Type‑C cable with reinforced connector. Special 35% discount.',
    category: 'electronics',
    subcategory: 'cable',
    image: 'https://images.priceoye.pk/joyroom-s-uc027a9-3a-type-c-cable-pakistan-priceoye-w24r7-500x500.webp',
    discountRate: 0.65,
    rating: { rate: 4.5, count: 42 }
  },
  {
    id: 'e-local-41',
    title: 'New Arrival — X2 500 Xtreme Speed Type‑C Cable',
    price: 1.6,
    description: 'X2 500 Xtreme — fast charging Type‑C cable with nylon braid and reinforced ends. New Arrival — grab yours!',
    category: 'electronics',
    subcategory: 'cable',
    image: 'https://images.priceoye.pk/x2-xtreme-3a-fast-charging-cable-pakistan-priceoye-wgxg3-500x500.webp',
    discountRate: 1.0,
    rating: { rate: 4.3, count: 30 }
  },
  {
    id: 'e-local-42',
    title: 'X2 600 Xtreme Pro Braided Cable — 35% OFF',
    price: 1.8,
    description: 'X2 600 Xtreme Pro — premium braided cable with fast charging support and superior durability. Now 35% OFF.',
    category: 'electronics',
    subcategory: 'cable',
    image: 'https://images.priceoye.pk/x2-xtreme-charging-cable-pakistan-priceoye-3cvz4-500x500.webp',
    discountRate: 0.65,
    rating: { rate: 4.4, count: 38 }
  },
  {
    id: 'e-local-43',
    title: 'New Arrival — Airox CB‑10 3‑in‑1 MultiPort Cable',
    price: 1.1,
    description: 'Airox CB‑10 — versatile 3‑in‑1 cable (Type‑C/Micro/Lightning) for everyday convenience. New Arrival and ready to ship!',
    category: 'electronics',
    subcategory: 'cable',
    image: 'https://images.priceoye.pk/airox-charging-cable-cb-10-pakistan-priceoye-jityg-500x500.webp',
    discountRate: 1.0,
    rating: { rate: 4.2, count: 26 }
  },
  {
    id: 'e-local-44',
    title: 'New Arrival — Bluks BX‑451 60W PowerLink Cable',
    price: 2.1,
    description: 'Bluks BX‑451 — reliable 60W USB‑C to USB‑C cable for fast PD charging and robust daily use. New Arrival — trending now.',
    category: 'electronics',
    subcategory: 'cable',
    image: 'https://images.priceoye.pk/bluks-bx-451-60w-charging-cable-pakistan-priceoye-z6z0y-500x500.webp',
    discountRate: 1.0,
    rating: { rate: 4.6, count: 33 }
  }
];

// 10 Men's T-Shirts (local) with 50% discount
export const localMenClothing = [
  {
    id: 'm-local-1',
    title: "Men's Classic Crewneck Tee – White",
    price: 19.99,
    description: "Soft cotton crewneck T-shirt in crisp white. Regular fit, breathable fabric. Sizes S–XXL.",
    category: "men's clothing",
    image: "https://images.pexels.com/photos/6787005/pexels-photo-6787005.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=600",
    discountRate: 0.5,
    rating: { rate: 4.4, count: 180 }
  },
  {
    id: 'm-local-2',
    title: "Men's Sports Jersey Tee – Charcoal",
    price: 24.99,
    description: "Athletic jersey T-shirt with moisture-wicking knit for training and casual days.",
    category: "men's clothing",
    image: "https://images.pexels.com/photos/2219801/pexels-photo-2219801.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=600",
    discountRate: 0.5,
    rating: { rate: 4.1, count: 95 }
  },
  {
    id: 'm-local-3',
    title: "Men's Active Tee – Heather Gray",
    price: 21.99,
    description: "Lightweight performance tee with quick-dry fabric. Ideal for running and hoops.",
    category: "men's clothing",
    image: "https://images.pexels.com/photos/4719821/pexels-photo-4719821.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=600",
    discountRate: 0.5,
    rating: { rate: 4.3, count: 122 }
  },
  {
    id: 'm-local-4',
    title: "Men's Premium Cotton Tee – Black",
    price: 22.99,
    description: "Everyday premium cotton T-shirt in classic black. Tagless comfort neckline.",
    category: "men's clothing",
    image: "https://images.pexels.com/photos/7148913/pexels-photo-7148913.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=600",
    discountRate: 0.5,
    rating: { rate: 4.5, count: 210 }
  },
  {
    id: 'm-local-5',
    title: "Men's Graphic Crew Tee – Print",
    price: 23.99,
    description: "Soft crewneck tee with bold front print. Breathable and durable wash after wash.",
    category: "men's clothing",
    image: "https://images.pexels.com/photos/2769325/pexels-photo-2769325.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=600",
    discountRate: 0.5,
    rating: { rate: 4.2, count: 160 }
  },
  {
    id: 'm-local-6',
    title: "Men's Everyday Tee – Navy",
    price: 18.99,
    description: "Classic short-sleeve T-shirt in navy. Breathable cotton blend for daily wear.",
    category: "men's clothing",
    image: "https://images.pexels.com/photos/2883383/pexels-photo-2883383.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=600",
    discountRate: 0.5,
    rating: { rate: 4.0, count: 88 }
  },
  {
    id: 'm-local-7',
    title: "Men's Relaxed Tee – Earth Tone",
    price: 19.49,
    description: "Relaxed-fit tee for effortless style. Soft hand-feel and easy drape.",
    category: "men's clothing",
    image: "https://images.pexels.com/photos/13335594/pexels-photo-13335594.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=600",
    discountRate: 0.5,
    rating: { rate: 4.1, count: 74 }
  },
  {
    id: 'm-local-8',
    title: "Men's Twin-Pack Crew Tees – White",
    price: 29.99,
    description: "Pack of two versatile white crewneck tees. Great value for everyday basics.",
    category: "men's clothing",
    image: "https://images.pexels.com/photos/6787008/pexels-photo-6787008.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=600",
    discountRate: 0.5,
    rating: { rate: 4.6, count: 260 }
  },
  {
    id: 'm-local-9',
    title: "Men's Classic Tee – White (Back Print)",
    price: 21.49,
    description: "Classic white tee with minimalist back detail. Soft fabric and regular fit.",
    category: "men's clothing",
    image: "https://images.pexels.com/photos/6786894/pexels-photo-6786894.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=600",
    discountRate: 0.5,
    rating: { rate: 4.2, count: 130 }
  },
  {
    id: 'm-local-10',
    title: "Men's Outdoor Tee – Lightweight",
    price: 20.99,
    description: "Lightweight tee for weekend adventures. Breathable and easy to layer.",
    category: "men's clothing",
    image: "https://images.pexels.com/photos/16785861/pexels-photo-16785861.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=600",
    discountRate: 0.5,
    rating: { rate: 4.0, count: 92 }
  }
];

// 10 Women's T-Shirts (local) with 50% discount
export const localWomenClothing = [
  {
    id: 'w-local-1',
    title: "Women's Crewneck Tee – White",
    price: 18.99,
    description: "Soft cotton crew in bright white. Flattering regular fit. Sizes XS–XL.",
    category: "women's clothing",
    image: "https://images.pexels.com/photos/6786614/pexels-photo-6786614.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=600",
    discountRate: 0.5,
    rating: { rate: 4.3, count: 175 }
  },
  {
    id: 'w-local-2',
    title: "Women's Cropped Tee – Off-White",
    price: 19.99,
    description: "Trendy cropped T-shirt with soft stretch. Pairs perfectly with high-waist denim.",
    category: "women's clothing",
    image: "https://images.pexels.com/photos/17243499/pexels-photo-17243499.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=600",
    discountRate: 0.5,
    rating: { rate: 4.1, count: 90 }
  },
  {
    id: 'w-local-3',
    title: "Women's Minimalist Tee – Shadow",
    price: 17.99,
    description: "Minimal tee with sleek silhouette. Super-soft feel and easy everyday look.",
    category: "women's clothing",
    image: "https://images.pexels.com/photos/8532607/pexels-photo-8532607.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=600",
    discountRate: 0.5,
    rating: { rate: 4.2, count: 102 }
  },
  {
    id: 'w-local-4',
    title: "Women's Everyday Tee – Gray",
    price: 18.49,
    description: "Everyday crewneck tee with comfortable stretch. Perfect with denim or skirts.",
    category: "women's clothing",
    image: "https://images.pexels.com/photos/6311475/pexels-photo-6311475.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=600",
    discountRate: 0.5,
    rating: { rate: 4.0, count: 118 }
  },
  {
    id: 'w-local-5',
    title: "Women's Classic Tee – White",
    price: 17.49,
    description: "Classic white T-shirt in breathable cotton. A timeless wardrobe essential.",
    category: "women's clothing",
    image: "https://images.pexels.com/photos/1734758/pexels-photo-1734758.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=600",
    discountRate: 0.5,
    rating: { rate: 4.1, count: 150 }
  },
  {
    id: 'w-local-6',
    title: "Women's Casual Tee – Soft Beige",
    price: 18.99,
    description: "Soft-touch tee with relaxed fit. Your new go-to for everyday comfort.",
    category: "women's clothing",
    image: "https://images.pexels.com/photos/8091024/pexels-photo-8091024.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=600",
    discountRate: 0.5,
    rating: { rate: 4.0, count: 86 }
  },
  {
    id: 'w-local-7',
    title: "Women's Fitted Tee – White",
    price: 19.49,
    description: "Fitted silhouette with gentle stretch. Pairs well with shorts or denim.",
    category: "women's clothing",
    image: "https://images.pexels.com/photos/3622624/pexels-photo-3622624.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=600",
    discountRate: 0.5,
    rating: { rate: 4.2, count: 110 }
  },
  {
    id: 'w-local-8',
    title: "Women's Photo Tee – Vintage Vibes",
    price: 22.99,
    description: "Graphic photo tee with vintage feel. Soft hand and all-day comfort.",
    category: "women's clothing",
    image: "https://images.pexels.com/photos/1734729/pexels-photo-1734729.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=600",
    discountRate: 0.5,
    rating: { rate: 4.3, count: 140 }
  },
  {
    id: 'w-local-9',
    title: "Women's Statement Tee – Multicolor",
    price: 21.99,
    description: "Bold multicolor tee with soft breathable fabric. Make every day a statement.",
    category: "women's clothing",
    image: "https://images.pexels.com/photos/19089120/pexels-photo-19089120.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=600",
    discountRate: 0.5,
    rating: { rate: 4.4, count: 97 }
  },
  {
    id: 'w-local-10',
    title: "Women's Crew Tee – Blue",
    price: 18.49,
    description: "Comfortable cotton tee in classic blue with volunteer-inspired vibe.",
    category: "women's clothing",
    image: "https://images.pexels.com/photos/7474978/pexels-photo-7474978.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=600",
    discountRate: 0.5,
    rating: { rate: 4.1, count: 90 }
  },
  
];

export function findLocalProductById(id) {
  const sid = String(id);
  return (
    localElectronics.find(p => String(p.id) === sid) ||
    localMenClothing.find(p => String(p.id) === sid) ||
    localWomenClothing.find(p => String(p.id) === sid)
  );
}
